// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.componente-audio {
    position: fixed;
    right: 90px;
    bottom: 80px;
    z-index: 999;
}

audio{
    background-color: #f0f3f4;
    width: 100%;
}

.contenedor-seleccion-audio, .contenedor-seleccion-velocidad {
    display: flex;
    margin: 0px;
}

.contenedor-seleccion-audio li{
    list-style: none;
    
}

.contenedor-seleccion-audio .btn-respuestas{
    background-color: #0094ce;
    color: white;    
    cursor: pointer;
    padding: 5px;
}
.contenedor-seleccion-audio .btn-respuestas:hover{
    background-color: #1b5a81; 
}

.contenedor-seleccion-audio .btn-select{
    background-color: #1b5a81; 
}


.contenedor-seleccion-velocidad {
    margin-top: -5px;
}

.contenedor-seleccion-velocidad li{
    list-style: none;
    background-color: #1b5a81;
    color: white;    
}

.contenedor-seleccion-velocidad li:hover{
    background-color: #216F94;
}

.contenedor-seleccion-velocidad .btn-velocidad{
    cursor: pointer;  
    padding: 5px; 
}

.contenedor-seleccion-velocidad .titulo-velocidad{
    background-color: #cccccc;
    color: black;
    cursor: default;
    padding: 5px;
}

.contenedor-seleccion-velocidad .titulo-velocidad:hover{
    background-color: #cccccc;
    color: black;
}



.contenedor-seleccion-velocidad  .btn-select{
    background-color: #216F94;
}`, "",{"version":3,"sources":["webpack://./src/app/components/reproductor-audio/reproductor-audio.component.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,WAAW;IACX,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,WAAW;AACf;;AAEA;IACI,gBAAgB;;AAEpB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,eAAe;IACf,YAAY;AAChB;AACA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;;AAGA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;;;AAIA;IACI,yBAAyB;AAC7B","sourcesContent":[".componente-audio {\r\n    position: fixed;\r\n    right: 90px;\r\n    bottom: 80px;\r\n    z-index: 999;\r\n}\r\n\r\naudio{\r\n    background-color: #f0f3f4;\r\n    width: 100%;\r\n}\r\n\r\n.contenedor-seleccion-audio, .contenedor-seleccion-velocidad {\r\n    display: flex;\r\n    margin: 0px;\r\n}\r\n\r\n.contenedor-seleccion-audio li{\r\n    list-style: none;\r\n    \r\n}\r\n\r\n.contenedor-seleccion-audio .btn-respuestas{\r\n    background-color: #0094ce;\r\n    color: white;    \r\n    cursor: pointer;\r\n    padding: 5px;\r\n}\r\n.contenedor-seleccion-audio .btn-respuestas:hover{\r\n    background-color: #1b5a81; \r\n}\r\n\r\n.contenedor-seleccion-audio .btn-select{\r\n    background-color: #1b5a81; \r\n}\r\n\r\n\r\n.contenedor-seleccion-velocidad {\r\n    margin-top: -5px;\r\n}\r\n\r\n.contenedor-seleccion-velocidad li{\r\n    list-style: none;\r\n    background-color: #1b5a81;\r\n    color: white;    \r\n}\r\n\r\n.contenedor-seleccion-velocidad li:hover{\r\n    background-color: #216F94;\r\n}\r\n\r\n.contenedor-seleccion-velocidad .btn-velocidad{\r\n    cursor: pointer;  \r\n    padding: 5px; \r\n}\r\n\r\n.contenedor-seleccion-velocidad .titulo-velocidad{\r\n    background-color: #cccccc;\r\n    color: black;\r\n    cursor: default;\r\n    padding: 5px;\r\n}\r\n\r\n.contenedor-seleccion-velocidad .titulo-velocidad:hover{\r\n    background-color: #cccccc;\r\n    color: black;\r\n}\r\n\r\n\r\n\r\n.contenedor-seleccion-velocidad  .btn-select{\r\n    background-color: #216F94;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
